import { Vue, Options } from 'vue-class-component';
import { mapState } from 'vuex';
import {
  ApartmentDTO,
  EntrancePlantDetailDTO,
  ApartmentInvitationDTO,
  ApartmentLabelDTO,
  AddressingType,
} from '@/../client-generator/generated-clients/plants';
import { PropType } from 'vue';
import { getUserInitialsForBubble } from '@/core/utils/utils';
import DialogEditLabel from './DialogEditLabel/DialogEditLabel.vue';
import DialogInviteResident from './DialogInviteResident/DialogInviteResident.vue';
import { SET_APP_LOADING } from '@/core/store/action-types';
import DialogConfirmDelete from '@/views/components/DialogConfirmDelete/DialogConfirmDelete.vue';

@Options({
  name: 'ContactSection',
  components: {
    DialogEditLabel,
    DialogConfirmDelete,
    DialogInviteResident,
  },
  props: {
    apartment: {
      type: Object as PropType<ApartmentDTO>,
      required: true,
    },
  },
  computed: {
    ...mapState(['currentEntrancePlant', 'adminView']),
  },
  watch: {
    'apartment.scsAddr'(newVal) {
      this.scsAddrNotValid =
        newVal < this.MIN_SCS_ADDRESS || newVal > this.MAX_SCS_ADDRESS;
    },
  },
  emits: ['onAddEditLabel', 'onDeleteLabel', 'update-list'],
})
export default class ContactSection extends Vue {
  currentEntrancePlant!: EntrancePlantDetailDTO;
  adminView!: boolean;
  apartment!: ApartmentDTO;
  labelToEdit: ApartmentLabelDTO | null = null;
  invitationToRemove: ApartmentInvitationDTO | null = null;
  isVisibleDialogEditLabel: boolean = false;
  isVisibleDialogInviteResident: boolean = false;
  isEdit: boolean = false;
  isVisibleDeleteInviteConfirm: boolean = false;

  readonly MIN_SCS_ADDRESS = 1;
  readonly MAX_SCS_ADDRESS = 3999;

  scsAddrNotValid: boolean = false;

  get isFloorsAddressing(): boolean {
    return this.currentEntrancePlant.addressingType === AddressingType.BuildingRiserFloorApartment;
  }

  get isCallWithCode(): boolean {
    return (
      this.currentEntrancePlant.addressingType ===
        AddressingType.DirectCall_Alphanumeric ||
      this.currentEntrancePlant.addressingType ===
        AddressingType.DirectCall_NumbersOnly
    );  
  }

  get currentInvitations() {
    return (
      this.currentEntrancePlant.apartmentInvitations?.filter(
        (i) =>
          i.apartmentId === this.apartment.apartmentId &&
          i.buildingId === this.apartment.buildingId &&
          i.floorId === this.apartment.floorId
      ) ?? []
    );
  }

  getLabelText(label: ApartmentLabelDTO) {
    if (this.isFloorsAddressing || this.isCallWithCode) {
      return label.callingCode;
    }

    if (label.isPrivate) {
      return `${label.surname} ${label.name}`;
    } else {
      return label.companyName;
    }
  }

  mounted(): void {
  }

  onAddLabelClick() {
    this.labelToEdit = null;
    this.isEdit = false;
    this.isVisibleDialogEditLabel = true;
  }

  onEditLabelClick(label: ApartmentLabelDTO) {
    this.labelToEdit = label;
    this.isEdit = true;
    this.isVisibleDialogEditLabel = true;
  }

  onDeleteLabelClick(labelId: string) {
    this.$emit('onDeleteLabel', labelId);
  }

  async onSaveLabel(newLabel: ApartmentLabelDTO) {
    this.hideLabelDialog();
    this.$emit('onAddEditLabel', newLabel);
  }

  userInitials(invitation: ApartmentInvitationDTO): string {
    return getUserInitialsForBubble(invitation);
  }

  hideLabelDialog() {
    this.isVisibleDialogEditLabel = false;
  }

  toggleInviteDialog() {
    this.isVisibleDialogInviteResident = !this.isVisibleDialogInviteResident;
  }

  toggleDeleteInviteConfirm(invitation: ApartmentInvitationDTO) {
    this.invitationToRemove = invitation;
    this.isVisibleDeleteInviteConfirm = !this.isVisibleDeleteInviteConfirm;
  }

  async handleDeleteInvite() {
    this.$store.dispatch(SET_APP_LOADING, true);
    try {
      //remove inviteToRemove
      //console.log(this.invitationToRemove);
    } finally {
      this.handleUpdateList();
      this.$store.dispatch(SET_APP_LOADING, false);
    }
  }

  handleUpdateList() {
    this.$emit('update-list');
  }
}
